import { BaseRowStore } from "./BaseRowStore";
import { TableStore } from "../TableStore";

/**
 * tableStore解构了children属性用于树形表，历史原因有一定的使用范围，保留row children的行的初始化
 */
export class RowStore extends BaseRowStore<TableStore> {

  constructor(tableStore: TableStore, src: any) {
    super(tableStore, src)
    // 树结构处理
    this.initChildrenRow()
  }
  initChildrenRow() {
    if (this.data?.children && Array.isArray(this.data.children) && this.data.children.length) {
      this.data.children = this.data.children.map((item: any) => {
        return new this.tableStore.extendRowStore(this.tableStore, item);
      });
      // 兼容以前的老代码，next上取值[{children: [rowStore], data.children: [rowStore]}]
      this.children = this.data.children
    }
  }
}